
import { Pipe, PipeTransform, ChangeDetectorRef, inject } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { AccountingDocumentMiscOperationType, AccountingDocumentPaymentTypeCode, AccountingDocumentTypeCode } from 'apps/debtor-portal/src/app/accounting-module/enums';

export type MergedAccountingDocumentType = 	AccountingDocumentTypeCode |
											AccountingDocumentPaymentTypeCode |
											AccountingDocumentMiscOperationType;

export interface IAccountingDocumentTypeBase {
	type?: AccountingDocumentTypeCode;
	paymentType?: AccountingDocumentPaymentTypeCode;
	miscOperationType?: AccountingDocumentMiscOperationType;
}

export interface IAccountingDocumentTypePipeOptions {
	isFull?: boolean;
	displaySubType?: boolean;
	displayMiscType?: boolean;
}

@Pipe({
	name: 'accountingType',
	pure: false
})
export class AccountingDocumentTypePipe extends TranslatePipe implements PipeTransform {
	private translateService: TranslateService;
	private changeDetectorRef: ChangeDetectorRef;

	defaultOptions: IAccountingDocumentTypePipeOptions = {
		isFull: false,
		displaySubType: false,
	};

	constructor() {
		const translateService = inject(TranslateService);
		const changeDetectorRef = inject(ChangeDetectorRef);

		super(translateService, changeDetectorRef);
	
		this.translateService = translateService;
		this.changeDetectorRef = changeDetectorRef;
	}

	transform<T extends IAccountingDocumentTypeBase>(document: T | string, options: IAccountingDocumentTypePipeOptions): string {
		options = {
			...this.defaultOptions,
			...options
		};

		// When displaySubType but displayMiscType is unknown, assume we want displayMiscType
		if (options.displaySubType && options.displayMiscType === undefined) {
			options.displayMiscType = true;
		}

		let documentType: string;

		if (typeof document === 'string') {
			documentType = document;
		} else  {
			documentType = document.type;

			if (options.displaySubType) {
				documentType = (document.type === AccountingDocumentTypeCode.Cashing && !!document.paymentType) ?
					document.paymentType :
					(document.type === AccountingDocumentTypeCode.Misc && !!document.miscOperationType && options.displayMiscType) ?
						document.miscOperationType :
						document.type;
			}
		}

		return super.transform(`AccountingDocuments.Types.${options.isFull ? 'Full' : 'Short'}.${documentType}`);
	}
}
